// extracted by mini-css-extract-plugin
export default {"willFade":"Gdac0dc","cvBanner":"G8f48dc","menuLoadingErrorMessage":"Gd4260f"};